module.exports = __webpack_public_path__ + "static/media/15-8.65e1fc10.mp3";